import React from 'react';
import { useDispatch } from 'react-redux';
import { Toast } from './toast';
import { hideToast, showToast } from '../../store/actions/toast';

export const ToastContainer = () => {
  const dispatch = useDispatch();

  const closeToast = () => {
    dispatch(hideToast());
  };

  return <Toast hideToast={closeToast} />;
};
